import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// ConfigProvider is not available in antd v3 - removed for compatibility
import 'core-js/stable/array';
import 'core-js/stable/date';
import 'core-js/stable/function';
import 'core-js/stable/map';
import 'core-js/stable/math';
import 'core-js/stable/number';
import 'core-js/stable/object';
import 'core-js/stable/parse-float';
import 'core-js/stable/parse-int';
import 'core-js/stable/set';
import 'core-js/stable/symbol';
import 'core-js/stable/weak-map';

import store from './store';
import Routes from './routes';
import App from './components/App/App';
import * as serviceWorker from './serviceWorker';
import { migrateTokens } from './utils/tokenStorage';
// Import antd LESS styles with custom theme variables
import './shared/style/antd-custom.less';
import './index.scss';

// Load Google Maps API dynamically
function loadGoogleMapsScript() {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY || '';

  if (!apiKey) {
    return;
  }

  // Check if script is already loaded
  if (document.querySelector('script[src*="maps.googleapis.com"]')) {
    return;
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

// Migrate existing tokens to encrypted format
migrateTokens();

// Load Google Maps script
loadGoogleMapsScript();

ReactDOM.render(
  <Provider store={store}>
    <App>
      <Routes />
    </App>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
